// extracted by mini-css-extract-plugin
module.exports = {"SliderCoin":"slider_SliderCoin__1pA56","valuesRange":"slider_valuesRange__2uI8_","value":"slider_value__2gxXt"};